import * as React from "react";
const SvgFiRrFaceSmileHearts = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-smile-hearts_svg__a)">
      <path
        fill="#062147"
        d="M6 12a1 1 0 0 1-1-1c0-1.892 1.232-4 3-4s3 2.108 3 4a1 1 0 1 1-2 0c0-1.054-.68-2-1-2s-1 .946-1 2a1 1 0 0 1-1 1m7-1a1 1 0 1 0 2 0c0-1.054.68-2 1-2s1 .946 1 2a1 1 0 1 0 2 0c0-1.892-1.232-4-3-4s-3 2.108-3 4m-1 7c3.107 0 5.563-2.162 5.666-2.254a.999.999 0 0 0-1.33-1.493c-.02.018-2.005 1.748-4.336 1.748s-4.311-1.726-4.336-1.748a1 1 0 0 0-1.33 1.493C6.437 15.838 8.893 18 12 18m7.957-11.998a.87.87 0 0 0 1.085 0c.983-.789 2.957-2.562 2.957-4.077C23.999.862 23.215 0 22.249 0s-1.75.862-1.75 1.925C20.499.862 19.715 0 18.749 0s-1.75.862-1.75 1.925c0 1.514 1.974 3.288 2.957 4.077zM5.25 17c-.966 0-1.75.862-1.75 1.925C3.5 17.862 2.716 17 1.75 17S0 17.862 0 18.925c0 1.514 1.974 3.288 2.957 4.077a.87.87 0 0 0 1.085 0c.983-.789 2.957-2.562 2.957-4.077C6.999 17.862 6.216 17 5.25 17m17.063-8.962a1 1 0 0 0-.689 1.234c.249.884.376 1.801.376 2.728 0 5.514-4.486 10-10 10-.927 0-1.845-.126-2.728-.376a1 1 0 0 0-.545 1.924c1.061.3 2.161.452 3.272.452 6.617 0 12-5.383 12-12 0-1.11-.152-2.211-.452-3.272a1 1 0 0 0-1.234-.69M1.181 15q.09 0 .182-.017a1 1 0 0 0 .803-1.164A10 10 0 0 1 2.001 12C2 6.486 6.486 2 12 2c.612 0 1.225.055 1.819.165A1 1 0 0 0 14.18.198 12 12 0 0 0 11.999 0C5.383 0 0 5.383 0 12c0 .731.066 1.465.198 2.181A1 1 0 0 0 1.18 15z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-smile-hearts_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSmileHearts;
